module.exports = __webpack_public_path__ + "static/media/report.2b784de7.svg";